<template>
  <router-link
    class="user-profile-link"
    :title="user.screen_name_ui"
    :to="userProfileLink(user)"
  >
    <slot>
      {{ at ? '@' : '' }}{{ user.screen_name_ui }}<UnicodeDomainIndicator
        :user="user"
      />
    </slot>
  </router-link>
</template>

<script>
import UnicodeDomainIndicator from 'src/components/unicode_domain_indicator/unicode_domain_indicator.vue'

import { useInstanceStore } from 'src/stores/instance.js'

import generateProfileLink from 'src/services/user_profile_link_generator/user_profile_link_generator'

const UserLink = {
  props: {
    user: Object,
    at: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    UnicodeDomainIndicator,
  },
  methods: {
    userProfileLink(user) {
      return generateProfileLink(
        user.id,
        user.screen_name,
        useInstanceStore().restrictedNicknames,
      )
    },
  },
}

export default UserLink
</script>
